import { styled } from "@mui/material";
import { TabPanel } from "@mui/lab";

export const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)} 0px`,
}));
